import { Router } from '@angular/router';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
export class DomainRedirectGuard {
    constructor(router) {
        this.router = router;
    }
    canActivate() {
        const hostname = window.location.hostname;
        const specialDomain = 'terms.noknok.co';
        if (hostname === specialDomain) {
            // Show terms-and-conditions while keeping URL '/'
            this.router.navigateByUrl('/terms-and-conditions', { skipLocationChange: true });
            return false;
        }
        // For all other domains, redirect to login
        this.router.navigate(['/portal/login']);
        return false; // prevents loading the current '' route
    }
}
DomainRedirectGuard.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function DomainRedirectGuard_Factory() { return new DomainRedirectGuard(i0.ɵɵinject(i1.Router)); }, token: DomainRedirectGuard, providedIn: "root" });
